module.exports = __webpack_public_path__ + "img/code.c2db4151.png";